import ApiClient from "../apiClient";

export interface UserProfile {
  id?: string;
  supabase_uid: string;
  email?: string;
  display_name?: string | null;
  avatar_url?: string | null;
  tier?: "free" | "fintheon" | "fintheon_plus" | "fintheon_pro";
  onboarding_complete?: boolean;
  app_state?: Record<string, unknown>;
  created_at?: string;
  updated_at?: string;
}

export interface OnboardingState {
  tourCompleted?: boolean;
  tourVersion?: string;
  completedAt?: string;
}

export class ProfileService {
  constructor(private client: ApiClient) {}

  async get(): Promise<UserProfile> {
    return this.client.get("/api/profile");
  }

  async update(fields: Partial<UserProfile>): Promise<UserProfile> {
    return this.client.put("/api/profile", fields);
  }

  async getAppState(): Promise<Record<string, unknown>> {
    return this.client.get("/api/profile/app-state");
  }

  async updateAppState(state: Record<string, unknown>): Promise<void> {
    await this.client.put("/api/profile/app-state", { state });
  }
}
